import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ApilistService } from 'src/app/services/apilist.service';
import { CommonService } from 'src/app/services/common.service';
import { GlobalService } from 'src/app/services/global.service';

@Component({
  selector: 'app-college-details',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './college-details.component.html',
  styleUrls: ['./college-details.component.scss'],
})
export class CollegeDetailsComponent implements OnInit {
  display: any = 'none';
  colleges: any;
  scope: any;
  collegeId: any;
  scopeId: any;
  fees: any;
  collegeDetails: any;
  id: any;

  collegeDetailsForm: UntypedFormGroup;

  searchval: any;

  error_messages = {
    collegeName: [{ type: 'required', message: 'Please select college name' }],
    scopeName: [{ type: 'required', message: 'Please select scope' }],
    feesVal: [{ type: 'required', message: 'Please enter fees' }],
  };
  adminName: any;
  adminImage: any;

  constructor(
    public utils: ApilistService,
    public commonservice: CommonService,
    public globalService: GlobalService,
    public formBuilder: UntypedFormBuilder
  ) {
    this.collegeDetailsForm = this.formBuilder.group({
      collegeName: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),

      scopeName: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),

      feesVal: new UntypedFormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });

    let admin = JSON.parse(localStorage.getItem('adminDetails'));
    let adminData = JSON.parse(admin);

    this.adminName = adminData[0].name;
    this.adminImage = adminData[0].image;
    if (this.adminImage == null || this.adminImage == undefined) {
      this.adminImage = 'assets/tenant-avatar.jpg';
    }
  }

  ngOnInit(): void {
    this.collegeDetailsForm.reset();
    // Get All College \\
    const servicePathCollege = this.utils.getApiConfigs('college');
    this.commonservice
      .invokeService(
        servicePathCollege[1].method,
        servicePathCollege[1].path,
        ''
      )
      .then((resp: any) => {
        if (resp.status_code == '200') {
          this.colleges = resp.data;
        }
      });

    // Get All Scope \\
    const servicePathScope = this.utils.getApiConfigs('scope');
    this.commonservice
      .invokeService(servicePathScope[1].method, servicePathScope[1].path, '')
      .then((resp: any) => {
        // console.log("Scope", resp);
        if (resp.status_code == '200') {
          this.scope = resp.data;
        }
      });

    const servicePath = this.utils.getApiConfigs('collegedetails');
    this.commonservice
      .invokeService(servicePath[1].method, servicePath[1].path, '')
      .then((resp: any) => {
        // console.log("colledetails", resp);
        if (resp.status_code == '200') {
          this.collegeDetails = resp.data;
        }
      });
  }

  addCollegeDetails() {
    let payload = {
      college_id: this.collegeId,
      scope_id: this.scopeId,
      fees: this.fees,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('collegedetails');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        if (resp.status_code == '200') {
          // console.log(resp);
          this.globalService.showSuccess('College Details added Successfully');
          this.display = 'none';
          this.collegeDetailsForm.reset();
          this.ngOnInit();
        } else if (resp.status_code == '400') {
          // console.log("data", resp.data);
          this.globalService.showError(resp.data);
          this.display = 'none';
        }
      });
  }

  openAdd() {
    this.display = 'block';
  }

  onCloseHandled() {
    this.display = 'none';
  }
}
